import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations, mapState } from 'vuex';
import mainViewMixin from '../mainViewMixin';
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import { EventBus } from '../../../services/eventbus.js';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import set from 'lodash/set';
export default {
  name: 'ViewNiotaClassicApplicationsApplicationDetails',
  mixins: [mainViewMixin],
  data: function data() {
    return {
      tabItem: 'tab-details',
      applicationObject: {},
      applicationCanBeEdited: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isIotHubManager: function isIotHubManager() {
      return this.permissions['IotHub.manage'];
    }
  }),
  watch: {
    $route: function $route() {
      this.getApplication(this.$route.params.applicationId);
    }
  },
  created: function created() {
    this.getApplication(this.$route.params.applicationId);
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['snackbar'])), {}, {
    breadCrumbsPath: function breadCrumbsPath() {
      if (get(this, 'applicationObject.account.name') && get(this, 'applicationObject.title')) {
        return [this.permissions['all.manage'] ? {
          text: this.applicationObject.account.name,
          to: "/account-mgmt/".concat(this.applicationObject.account.id)
        } : this.applicationObject.account.name, this.applicationObject.title];
      }

      return [];
    },
    addressSelected: function addressSelected(addressData) {
      var tmp = get(addressData, 'address.formatted_address');

      if (tmp) {
        set(this.applicationObject, 'data.address', {});
        this.applicationObject.data.address.formatted_address = tmp;
      }

      this.applicationObject.coordinates = {
        coordinates: addressData.coordinates
      };
      this.applicationObject = cloneDeep(this.applicationObject);
    },
    prepareSubmit: function prepareSubmit() {
      this.handleSubmit();
    },
    getApplication: function getApplication(applicationId) {
      var _this = this;

      return NiotaClassicApiService.applicationGet(applicationId).then(function (res) {
        _this.applicationObject = res.data.application;
        EventBus.$emit('update-breadcrumbs');
      });
    },
    viewAllApplications: function viewAllApplications() {
      this.$router.push({
        path: '/niota-classic/applications'
      });
    },
    updateItem: function updateItem(item) {
      this.applicationObject = cloneDeep(item);
    },
    getImageUrl: function getImageUrl(image) {
      if (/^http(?:s):\/\//i.test(image)) {
        return image;
      }

      return "".concat(process.env.VUE_APP_N1_API_PROTOCOL, "://").concat(process.env.VUE_APP_N1_API_HOST).concat(image);
    }
  })
};